import type { FC } from 'react'
import { SvgIconProps } from '@mui/material'
import { useFestiveVariants } from '@dhl/utils'

import { ParcelCatDefault } from './ParcelCatDefault.js'
import { ParcelCatChristmas } from './ParcelCatChristmas.js'
import { ParcelCatSinterklaas } from './ParcelCatSinterklaas.js'
import { ParcelCatEaster } from './ParcelCatEaster.js'

export const ParcelCat: FC<SvgIconProps> = (props) => {
  const Component = useFestiveVariants({
    easter: ParcelCatEaster,
    sinterklaas: ParcelCatSinterklaas,
    christmas: ParcelCatChristmas,
    default: ParcelCatDefault,
  })

  return <Component {...props} />
}
